import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { analyticsKeys } from '../analytics.keys';
import { getNewMembers } from '../analytics.service';
import { FiveMinutes, InitialRetryDelay } from '../constants';
export const useNewMembers = ({ subdomain = getSubdomain(), startDate, endDate, interval, ...options }) => {
    const q = useQuery({
        refetchInterval: query => (!query.state.data?.isComputed ? InitialRetryDelay : false),
        staleTime: FiveMinutes,
        ...options,
        queryKey: analyticsKeys.newMembers(subdomain, startDate, endDate, interval),
        queryFn: () => getNewMembers(subdomain, startDate, endDate, interval),
    });
    return { ...q, isPending: q.isPending || !q.data?.isComputed };
};
